var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPreviewIcon = function SvgPreviewIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31.2502193px",
    height: "20.8333334px",
    viewBox: "0 0 31.2502193 20.8333334",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.15.6-Setup-/-Location-/-Create-new-location-/-Step-1---hover-to-view-image",
    transform: "translate(-565.373701, -681.583333)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/03.Input-&-Dropdown/01.Without-discription-Copy-5",
    transform: "translate(516.000000, 624.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(0.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(45.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9778646,9.58333328 C22.9947917,9.58333328 26.0546875,10.5305989 28.8261719,12.3222656 C31.3313803,13.9401041 33.5664063,16.203125 35.2890626,18.8671875 C35.7331714,19.5554726 35.7357143,20.4393794 35.295573,21.1302083 C33.5794272,23.8164063 31.3489584,26.0878907 28.8450521,27.7005209 C26.0852865,29.4772136 23.0188802,30.4166667 19.9778646,30.4166667 C16.8684896,30.4166667 13.8802083,29.5052084 11.1035156,27.7063802 C8.63736973,26.1106771 6.4244791,23.8444011 4.70507805,21.1536458 C4.24851828,20.4452782 4.26497683,19.5313141 4.74674472,18.8398437 C6.83333327,15.8483073 9.23567703,13.5247396 11.8873698,11.9342448 C14.4876302,10.3743489 17.2096354,9.58333328 19.9778646,9.58333328 Z M20,13.75 C16.5482203,13.75 13.75,16.5482203 13.75,20 C13.75,23.4517797 16.5482203,26.25 20,26.25 C23.4501437,26.2460535 26.2460535,23.4501437 26.25,20 C26.25,16.5482203 23.4517797,13.75 20,13.75 Z M20,15.8333333 C22.3011865,15.8333333 24.1666667,17.6988135 24.1666667,20 C24.1666667,22.3011865 22.3011865,24.1666667 20,24.1666667 C17.6988135,24.1666667 15.8333333,22.3011865 15.8333333,20 C15.8333333,17.6988135 17.6988135,15.8333333 20,15.8333333 Z",
    id: "Combined-Shape"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreviewIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preview-icon.63a60c25.svg";
export { ForwardRef as ReactComponent };